import "../components/SapIM/IMprofiletraining.css";
import "../components/SapIM/IMwhyus.css";
import "../components/SAP/Header/Introsap.css";
import "../components/saponlinecom/onlinecoursegrid.css";
import "animate.css";

const Saphome = () => {
    return (<>
    </>
    );
}
export default Saphome;
